var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['collapse-row',_vm.collapsed?'collapsed':''],on:{"click":function($event){_vm.collapsed=!_vm.collapsed}}})}
var staticRenderFns = []

export { render, staticRenderFns }